"use client";

/* eslint-disable @next/next/no-head-element */
import Image from "next/image";
import { useTranslation } from "react-i18next";

import MButton from "components/atoms/Button";
import MotionBox from "components/atoms/MotionBox";
import Images from "styles/image-library";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div>
      <head>
        <title>{t("404Page.tab-title")}</title>
      </head>
      <div className="flex flex-col items-center justify-center w-full">
        <MotionBox
          animate={{ y: 20 }}
          transition={{
            repeat: Infinity,
            duration: 2,
            repeatType: "reverse",
          }}
          width="100vw"
          display="flex"
          mt={["5vh", "10vh"]}
          pt={{ base: "120px", md: "40px", "2xl": "unset" }}
          justifyContent="center"
        >
          <Image
            width={550}
            height={230}
            src={Images.i404}
            alt="Error 404 not found Illustration"
          />
        </MotionBox>
        <p className="pt-[48px] my-[32px] text-18">
          {t("404Page.page-not-cooked")}
        </p>
        <MButton
          variant="solid"
          width="200px"
          height="48px"
          font="text-xl"
          mb={["40px", "80px"]}
          href="/"
        >
          {t("404Page.go-to-homepage")}
        </MButton>
      </div>
    </div>
  );
};

export default NotFound;
